import { cloneElement, isValidElement, ReactElement } from "react";
import { ICON_SIZES } from "src/constants/icons";

type ReactIconProps = {
  size?: number;
  color?: string;
  className?: string;
};

function isReactIcon(
  element: ReactElement,
): element is ReactElement<ReactIconProps> {
  return typeof element.type === "function";
}

export const forceIconSize = ({
  icon,
  size = ICON_SIZES.SM,
}: {
  icon: ReactElement | null;
  size?: (typeof ICON_SIZES)[keyof typeof ICON_SIZES];
}) => {
  return isValidElement(icon) && isReactIcon(icon)
    ? cloneElement(icon, {
        size,
      })
    : icon;
};
